import masonry from 'vue-next-masonry';

export default {
    install(app) {
        app.use(masonry);
    },
};
